import { UIKitIcon } from '../icon';

export const extLinkIcon: UIKitIcon = {
  name: 'ext-link',
  // eslint-disable-next-line max-len
  data: '<svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" stroke="#0A0A0A" stroke-linecap="round" stroke-linejoin="round"><path d="M13.836 10.081h-4.78a1.98 1.98 0 0 0-1.98 1.98v10.883a1.98 1.98 0 0 0 1.98 1.98H19.94a1.98 1.98 0 0 0 1.98-1.98v-4.78M16.265 7.076h8.659v8.66M12.557 19.443 24.924 7.076"/></g><defs><clipPath id="a"><path fill="#fff" transform="translate(6.5 6.5)" d="M0 0h19v19H0z"/></clipPath></defs></svg>',
};
